<template>
  <div>
    <section>
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Late deliveries</h1>
          </v-col>
        </v-row>

        <v-row :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col cols="12" sm="12" md="3">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="1" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn text large @click="refresh" v-on="on">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-col>

          <v-col md="2" sm="10">

                <download-csv
                  class="btn btn-default"
                  :data="csvExport()"
                  name="lateDeliveries.csv">
                  <v-btn icon large>
                    <v-icon color="blue">cloud_download</v-icon>
                  </v-btn>
                </download-csv>

          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>

      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedLateExceptions"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center" v-for="(header, index) in headers"
                :key="index">{{props.item[header.value]}}
            </td>
          </tr>
        </template>
      </v-data-table>
    </section>
  </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "LateDeliveries",
        data() {
            return {
                search: '',
                loading: false,
                reload: false,
                timer: '',
                headers: [
                    {text: 'Service', value: 'service_name', align: 'center'},
                    {text: 'Name', value: 'name', align: 'center', sortable: true},
                    {text: 'Address', value: 'street1', align: 'center', sortable: true},
                    {text: 'Postcode', value: 'postcode', align: 'center', sortable: true},
                    {text: 'Region', value: 'region_name', align: 'center', sortable: true},
                    {text: 'Invoice No', value: 'invoice', align: 'center', sortable: true},
                    {text: 'Tracking Id', value: 'tracking', align: 'center', sortable: true},
                    {text: 'Date', value: 'date', align: 'center', sortable: true},
                    {text: 'Time Slot', value: 'time_slot', align: 'center', sortable: true},
                    {text: 'Estimated time updated', value: 'estimated_time_updated', align: 'center', sortable: true},
                    {text: 'Client Name', value: 'client_name', align: 'center', sortable: true},
                ],
            }
        },
        methods: {
            refresh() {
                this.reload = !this.reload;
            },
            csvExport() {
                let arrData = this.renderedLateExceptions;

                // if (arrData.length > 0) {
                    return arrData;
                // } else {
                //     this.$store.commit('displaySnackbar', 'Couldn\'t export the late deliveries because the array is empty');
                // }
            },
        },
        computed: {
            renderedLateExceptions() {
                if (this.LateDeliveries === null || this.LateDeliveries === undefined) {
                    return [];
                } else {
                   return this.LateDeliveries.map((delivery) => {
                     delivery.time_slot = 'From ' + delivery.time_window_start.split(' ')[1] + ' to ' + delivery.time_window_end.split(' ')[1];
                     return delivery;
                   });
                }
            },
            // onHold() {
            //     let on_hold = this.renderedLateExceptions.filter((exception) => {
            //         return exception.status === 'On Hold'
            //     });
            //     return on_hold
            // },
            // rescheduled() {
            //     let rescheduled = this.renderedLateExceptions.filter((exception) => {
            //         return exception.status === 'Rescheduled'
            //     });
            //     return rescheduled
            // },
            // canceled() {
            //     let canceled = this.renderedLateExceptions.filter((exception) => {
            //         return exception.status === 'Canceled'
            //     });
            //     return canceled
            // },
        },
        asyncComputed: {
            async LateDeliveries() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/deliveries/late')
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            return [];
                        });
                }
            }
        },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/LateDeliveries.vue